import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { AppointmentType, AppointmentTypeWrite, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useCreateAppointmentType(): UseMutationResult<
  AxiosResponse<AppointmentType>,
  AxiosError<ErrorMessage>,
  AppointmentTypeWrite
> {
  const queryClient = useQueryClient();

  const createAppointmentType = (
    appointmentType: AppointmentTypeWrite,
  ): Promise<AxiosResponse<AppointmentType>> => {
    return client.post('appointment-types/', appointmentType);
  };

  return useMutation(createAppointmentType, {
    onSuccess: () => {
      queryClient.invalidateQueries('appointmentType');
      queryClient.invalidateQueries({
        queryKey: ['appointmentPayRateLookups'],
      });
    },
  });
}
